import Swiper from 'swiper';
import { Pagination, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

const Home = {
  init() {
    if (document.querySelector('.home-hero .swiper')) {
      new Swiper('.home-hero .swiper', {
        modules: [Pagination, EffectFade, Autoplay],
        autoplay: {
          delay: 3000,
        },
        loop: true,
        speed: 5000,
        pagination: {
          el: document.querySelector<HTMLElement>('.home-slidepager'),
          bulletClass: 'home-slidepager__bullet',
          bulletActiveClass: 'is-active',
          modifierClass: '__pager__',
          clickable: true,
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
      });
    }
    const LottieWavePcs = document.querySelectorAll<HTMLElement>('.LottieWavePc');
    if (LottieWavePcs.length) {
      LottieWavePcs.forEach(el=>{
        lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: './assets/lib/bg-wave_pc.json',
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
          },
        });
      })
    }
    const LottieWaveMobiles = document.querySelectorAll<HTMLElement>('.LottieWaveMobile');
    if (LottieWaveMobiles.length) {
      LottieWaveMobiles.forEach(el=>{
        lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: './assets/lib/bg-wave_sp.json',
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
          },
        });
      })
    }
  },
};
export { Home };
